import { render, staticRenderFns } from "./StrengthIndicator.vue?vue&type=template&id=3425f8e2&"
import script from "./StrengthIndicator.vue?vue&type=script&lang=js&"
export * from "./StrengthIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports